import React from 'react';
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { goTo } from "../tools";
import { callService } from '../tools';
import TextField from 'material-ui/TextField';

const iconCircule = "icon-circle";
const ojitoCerrado = "eye-hidden";
const errorMessageTT = "Ocurrio un error, intente más tarde.";
const errorMessageContra = "La nueva contraseña no puede ser la misma que las contraseñas utilizadas anteriormente."
const validacion = "VALIDACIÓN";
const iconCirculeDove = "icon-circle-dove";
const modalValidPassCam = "modal-validador-password";
const estiloColmd8 = "col-md-8";
const ojito = "eye-visible";
const modalValidPassBodyCam = "modal-validador-password-body";
const palabraError = "error";
const iconCirculeDovequis = "icon-equis-circulo"
const estiloColpxCam = "0px 8px 0px 0px";
const colorExito = "colorExito";
const campoRequ = "Campo requerido.";
const colorNormal = "colorNormal";
const colorError = "colorError";
const servicioActual = "miPerfil.actualizarPreguntas";
var contador = 0;
var letras_minusculas = "abcdefghyjklmnñopqrstuvwxyz";
var letrasmayusculas = "ABCDEFGHYJKLMNÑOPQRSTUVWXYZ";

const mapState = (state) => {
    return {
        dispositivo: state.global.dispositivo
    };
}

const mapDispatch = (dispatch) => {
    return {
        tagManager: (oDataTagManager) => {
            dispatch(oDataTagManager);
        },
        loader: (show) => {
            dispatch({ "type": "LOADER", "show": show });
        }
    }
}

const handleKeyPress = (input) => {
    const inputs = document.getElementsByTagName('input');
    const inputActual = input.name;
    for (let index = 0; index < inputs.length; index++) {
        if (inputActual === inputs[index].name) {
            switch (input.name) {
                case "password":
                    document.getElementById(inputs[index + 1].id).focus();
                    break;

                case "confpassword":
                    document.getElementById(inputs[index].id).blur();
                    break;
                default:
                    break;
            }
        }
    }
}

const campo = ({ input, label, type, param, max, fnToggle, clase, error }) => {
    return (
        <MuiThemeProvider>
            <TextField
                {...input}
                floatingLabelText={label}
                fullWidth={true}
                underlineStyle={{ borderColor: '#AAC3EE' }}
                underlineFocusStyle={{ borderColor: '#FF6B0B' }}
                floatingLabelStyle={floatingLabelStyleSettings}
                floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
                type={type}
                errorText={error}
                maxLength={max}
                onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                        handleKeyPress(input);
                    }
                }}
                onChange={(event) => { input.onChange(event); }}
            />
        </MuiThemeProvider>
    );
};

const campoSettings = {
    fontFamily: 'OpenSans',
    fontWeight: 'normal',
    mixBlendMode: 'normal',
    fontStyle: 'normal',
};

const floatingLabelStyleSettings = {
    ...campoSettings,
    color: '#33445F',
    letterSpacing: '0.5px',
    lineHeight: '16px',
};

const floatingLabelFocusStyleSettings = {
    ...campoSettings,
    letterSpacing: '0.4px',
    color: '#FF6B0B',
    lineHeight: '16px',
};

class CambiarContrasena extends React.Component {
    state = {
        showValidatorPass: false,
        caracteresCompletos: 'vacio',
        caracterConsecutivo: 'vacio',
        caracterMayuscula: 'vacio',
        caracterGNP: 'vacio',
        caracterConsecutivoIgual: 'vacio',
        espacioEnBlanco: 'vacio',
        caracteresNumericos: 'vacio',
        caracterEspecial: 'vacio',
        contraExitosa: false,
        caracteresAlfabeticos: 'vacio',
        btnHabilitado: 'deshabilita',
        showPass: true,
        showPassActual: true,
        showConfPass: true,
        showResp1: true,
        showResp2: true,
        password: "",
        showTooltip: false,
        mensaje: "",
        type: "",
        titulo: "",
        errorRequeridoContraActual: false,
        errorRequeridoContra: false,
        errorRequeridoContraConfir: false
    }

    componentWillMount = () => {
        console.log('hola');
    }

    viewPassConf = () => {
        this.setState({ showConfPass: !this.state.showConfPass });
    }

    viewPassActual = () => {
        this.setState({ showPassActual: !this.state.showPassActual });
    }

    viewPass = () => {
        this.setState({ showPass: !this.state.showPass });
    }

    viewPassResp1 = () => {
        this.setState({ showResp1: !this.state.showResp1 });
    }

    viewPassResp2 = () => {
        this.setState({ showResp2: !this.state.showResp2 });
    }

    lanzaErrorContra = (bandera) => {
        console.log(bandera);
        if (bandera) {
            setTimeout(() => {
                this.setState({ contraExitosa: bandera });
            }, 100);
        } else {
            this.setState({ contraExitosa: bandera });
        }
    }

    handleChange = (sParam, e) => {
        this.setState({ [sParam]: e.target.value });
        this.validate(sParam, e.target.value);
    }

    confirmPasswordCambia = () => {
        const confirPasswordC = document.getElementsByName('confpassword')[0].value;
        const valuePassword = document.getElementsByName('password')[0].value;
        if (confirPasswordC !== '' && valuePassword !== '') {
            if (valuePassword === confirPasswordC) {
                this.lanzaErrorContra(true);

                this.muestraTooltip(false);

            } else {
                this.lanzaErrorContra(false);

                this.muestraTooltip(true, 'error', 'Error', 'Las contraseñas no coinciden');
            }
        } else {
            this.lanzaErrorContra(false);

            this.validaBotonDeshabilitado();
        }
        setTimeout(() => {
            this.validaBotonDeshabilitado();
        }, 500);
    }

    muestraTooltip = (show, type?, titulo?, mensaje?) => {
        setTimeout(() => {
            this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
        }, 500);
    }

    cierraTooltip = e => {
        console.log('cierra');
        this.setState({
            showTooltip: !this.state.showTooltip
        });
    }

    validaPasswordCambiaCon = () => {
        const valuePasswordC = document.getElementsByName('password')[0].value;
        function checkMayus(stri) {
            return stri.toLowerCase() !== stri;
        }
        if (valuePasswordC === '') {
            this.setState({ caracterConsecutivoIgual: 'vacio' });
            this.setState({ caracterGNP: 'vacio' });
            this.setState({ caracteresCompletos: 'vacio' });
            this.setState({ caracterConsecutivo: 'vacio' });
            this.setState({ caracterMayuscula: 'vacio' });
            this.setState({ caracteresAlfabeticos: 'vacio' });
            this.setState({ espacioEnBlanco: 'vacio' });
            this.setState({ caracterEspecial: 'vacio' });
            this.setState({ caracteresNumericos: 'vacio' });
        } else {
            this.caracteresLetras(valuePasswordC);
            this.caracteresMayusLetra(valuePasswordC);
            this.caracterConFuncConfirma(valuePasswordC);
            this.caracteresAlfan(valuePasswordC);
            checkMayus(valuePasswordC) === false ? this.setState({ caracterMayuscula: 'error' }) : this.setState({ caracterMayuscula: 'exito' });
        }
        setTimeout(() => {
            this.validaBotonDeshabilitado();
        }, 500);
    }

    caracterConFuncConfirma = (valuePasswordC) => {
        const ABCDAR = "abcdefghijklmnopqrstuvwxyz";
        const NUMEROSA = "0123456789";

        for (var i = 0; i < valuePasswordC.length; i++) {
            var cadena = valuePasswordC.substr(i, 3).toLowerCase();
            if (cadena.length === 3 && (ABCDAR.indexOf(cadena) >= 0 || NUMEROSA.indexOf(cadena) >= 0)) {
                this.setState({ caracterConsecutivo: 'error' });
                break;
            } else {
                this.setState({ caracterConsecutivo: 'exito' });
            }
        }

        (/([\w])\1{2,}/.test(valuePasswordC)) ? this.setState({ caracterConsecutivoIgual: 'error' }) : this.setState({ caracterConsecutivoIgual: 'exito' });
    }

    validaBotonDeshabilitado = () => {
        if (this.state.contraExitosa && this.state.caracteresCompletos === 'exito' && this.state.caracterMayuscula === 'exito'
            && this.state.caracterGNP === 'exito' && this.state.espacioEnBlanco === 'exito' && this.state.caracterConsecutivoIgual === 'exito'
            && this.state.caracteresAlfabeticos === 'exito' && this.state.caracteresNumericos === 'exito' && this.state.caracterEspecial === 'exito'
            && this.state.caracterConsecutivo === 'exito') {
            this.setState({ btnHabilitado: 'habilita' })
        } else {
            this.setState({ btnHabilitado: 'deshabilita' })
        }
    }

    caracteresMayusLetra = (valuePasswordX) => {
        (/\s+/.test(valuePasswordX)) ? this.setState({ espacioEnBlanco: 'error' }) : this.setState({ espacioEnBlanco: 'exito' });
        valuePasswordX.length <= 7 || valuePassword.length > 24 ? this.setState({ caracteresCompletos: 'error' }) : this.setState({ caracteresCompletos: 'exito' });
        valuePasswordX.toLowerCase().includes("gnp") ? this.setState({ caracterGNP: 'error' }) : this.setState({ caracterGNP: 'exito' });
    }

    caracteresAlfan = (valuePassword) => {
        for (var i = 0; i < valuePassword.length; i++) {
            if ((letras_minusculas.indexOf(valuePassword.charAt(i), 0) !== -1) || letrasmayusculas.indexOf(valuePassword.charAt(i), 0) !== -1) {
                contador = contador + 1;
            } else {
                console.log('no existe');
            }
        }

        if (contador < 4) {
            this.setState({ caracteresAlfabeticos: 'error' });
        } else {
            this.setState({ caracteresAlfabeticos: 'exito' });
        }
    }

    caracteresLetras = (valuePasswordS) => {
        (/[0-9]/.test(valuePasswordS) === false) ? this.setState({ caracteresNumericos: 'error' }) : this.setState({ caracteresNumericos: 'exito' });
        (!/^[a-z0-9]+$/i.test(valuePasswordS)) ? this.setState({ caracterEspecial: 'exito' }) : this.setState({ caracterEspecial: 'error' });
    }

    validaCaracteresColor = (value) => {
        if (this.state[value] === 'vacio') {
            return colorNormal;
        } else if (this.state[value] === 'exito') {
            return colorExito;
        } else {
            return colorError;
        }
    }

    validaCaracteresIcon = (valueSSSS) => {
        if (this.state[valueSSSS] === 'vacio') {
            return iconCircule;
        } else if (this.state[valueSSSS] === 'exito') {
            return iconCirculeDove;
        } else {
            return iconCirculeDovequis;
        }
    }

    handleBlurPasswordcambia = () => {
        if (this.state.caracteresCompletos === 'exito' && this.state.caracterMayuscula === 'exito'
            && this.state.caracterGNP === 'exito' && this.state.espacioEnBlanco === 'exito' && this.state.caracterConsecutivoIgual === 'exito'
            && this.state.caracteresAlfabeticos === 'exito' && this.state.caracteresNumericos === 'exito' && this.state.caracterEspecial === 'exito'
            && this.state.caracterConsecutivo === 'exito') {
            this.setState({ showValidatorPass: false });
        } else {
            this.setState({ showValidatorPass: true });
        }
        this.validaPasswordConfirmCambia();
    }

    validaPasswordConfirmCambia = () => {
        const confpassword = document.getElementsByName('confpassword')[0].value;
        if (confpassword !== '') {
            console.log('entro')
            this.confirmPasswordCambia();
        }
    }

    toggleCambia = (sParam) => {
        console.log('togle');
        this.setState({ [sParam]: !this.state[sParam] });
    }

    handleFocusPasswordCA = () => {
        this.setState({ showValidatorPass: true });
    }

    regresar = () => {
        goTo("mi-perfil");
    }

    sigue = () => {
        var contrasenaActualC = document.getElementsByName('passwordActual')[0].value;
        var nuevaContr = document.getElementsByName('password')[0].value;
        var contrasenaConfirm = document.getElementsByName('confpassword')[0].value;

        if (nuevaContr !== contrasenaConfirm) {
            console.log("Las contraseñas no coinciden");
        } else {
            if (contrasenaActualC !== '' && nuevaContr !== '' && contrasenaConfirm !== '' && this.state.contraExitosa) {
                this.mandaActualizarContraCambia(contrasenaActualC, nuevaContr);
            } else {
                contrasenaActualC !== '' ? this.setState({ errorRequeridoContraActual: false }) : this.setState({ errorRequeridoContraActual: true });
                nuevaContr !== '' ? this.setState({ errorRequeridoContra: false }) : this.setState({ errorRequeridoContra: true });
                contrasenaConfirm !== '' ? this.setState({ errorRequeridoContraConfir: false }) : this.setState({ errorRequeridoContraConfir: true });
            }
        }
    }

    cierraModal = () => {
        goTo("mi-perfil");
    }

    mandaActualizarContraCambia = (oldPassword, newPassword) => {
        this.props.loader(true);
        new callService({
            service: servicioActual,
            secure: true,
            data: { "pass": oldPassword, "p1": "PSC15", "r1": "negro", "p2": "PSC04", "r2": "nissan" }
        }).execute().then((oResult) => {
            console.log(oResult);
            if (oResult.actualizarPreguntasClienteResponse.banExito) {
                new callService({
                    service: "miPerfil.actualizarContrasena",
                    secure: true,
                    data: { "newpass": newPassword, "p1": "PSC15", "r1": "negro", "p2": "PSC04", "r2": "nissan" }
                }).execute().then((oResult) => {
                    console.log(oResult);
                    console.log('aqui');
                    if (oResult.actualizarContrasenaClienteResponse) {
                        this.cerrarloader();
                        console.log('aqui entro')
                        $('#modal-final').modal({ backdrop: 'static', keyboard: false });
                    } else {
                        console.log('aqui');
                        this.muestraError();
                        this.cerrarloader();
                    }
                }).catch((error) => {
                    console.log('error al actualizar contraseña', error);
                    if (error.message.codigoError === 'eCl00026') {
                        this.cerrarloader();
                        this.muestraErrorContra();
                    } else {
                        this.cerrarloader();
                        this.muestraError();
                    }
                });
            } else {
                console.log('aqui entra tambien');
                this.cerrarloader();
                this.muestraError();
            }
        }).catch((error) => {
            console.log('aqui entra tambien');
            this.cerrarloader();
            this.muestraError();
        });
    }

    cerrarloader = () => {
        this.props.loader(false);
    }

    muestraError = () => {
        this.muestraTooltip(true, palabraError, validacion, errorMessageTT);
    }

    muestraErrorContra = () => {
        this.muestraTooltip(true, palabraError, validacion, errorMessageContra);
    }

    render() {
        return <div>
            <ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
                show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
            </ModalSintillo>
            <div className="txt-center" style={{ padding: '0px 28px' }}>
                <div id="title-Registro">
                    <span className="material-icons bi bi-arrow-left" style={{ float: "left", cursor: "pointer", marginTop: "20px" }} onClick={this.regresar}>
                        arrow_back
                    </span>
                    <label id="txt-Registro">Cambiar contraseña</label>
                    <br />
                    <hr className="label-hr" />
                </div>
                <div className='row '>
                    <div className='col-md-2'></div>
                    <div className={estiloColmd8}>
                        <div className='row'>
                            <div className='col-md-12 text-center'>
                                <label className="titulo-accion" style={{ margin: "24px 0px 24px 5px" }}>
                                    Completa los siguientes datos
                                </label>
                            </div>
                            <div className="col-md-6">
                                <div className="subtitle-cambio-contrasena text-center">
                                    Ingresa tu contraseña actual
                                </div>
                            </div>
                            <div className="col-md-9 marginLeft-cambioPass">
                                <div className='row' style={{ width: '100%' }}>
                                    <div className="col-md-6" id="campo-password-cambiaPassword">
                                        <Field
                                            name="passwordActual" label="Contraseña actual" component={campo} max="24" type={this.state.showPassActual ? "password" : "text"}
                                            props={{ param: this.state.showPassActual, fnToggle: this.toggleCambia.bind(this, "showPassActual") }}
                                            error={this.state.errorRequeridoContraActual ? campoRequ : null}
                                        />
                                        <button type="button" className={this.state.showPassActual ? ojito : ojitoCerrado} onClick={() => { this.viewPassActual() }}></button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6" style={{ marginTop: "32px" }}>
                                <div className="subtitle-cambio-contrasena text-center">
                                    Ingresa tu nueva contraseña
                                </div>
                            </div>
                            <div className="col-md-9 marginLeft-cambioPass">
                                <div className='row' style={{ width: '100%' }}>
                                    <div className="col-md-6 col-sm-12" id="campo-password-cambiaPassword">
                                        <Field
                                            name="password" label="Nueva contraseña" component={campo} max="24" type={this.state.showPass ? "password" : "text"}
                                            onFocus={this.handleFocusPasswordCA} onBlur={this.handleBlurPasswordcambia}
                                            props={{ param: this.state.showPass, fnToggle: this.toggleCambia.bind(this, "showPass") }}
                                            onChange={this.validaPasswordCambiaCon} error={this.state.errorRequeridoContra ? campoRequ : null}
                                        />
                                        <button type="button" className={this.state.showPass ? ojito : ojitoCerrado} onClick={() => { this.viewPass() }}></button>
                                        {
                                            this.state.showValidatorPass &&
                                            <div className={modalValidPassCam}>

                                                <div className={modalValidPassBodyCam}>
                                                    <span style={{ margin: { estiloColpxCam }, width: '10%' }}
                                                        className={this.validaCaracteresIcon('caracteresCompletos')} >
                                                    </span>
                                                    <div className={this.validaCaracteresColor('caracteresCompletos')}>
                                                        <label className="label-text-modal-password">Debe ser al menos de 8 caracteres y máximo 24 caracteres.</label>
                                                    </div>
                                                </div>
                                                <div className={modalValidPassBodyCam}>
                                                    <span style={{ margin: { estiloColpxCam } }} className={this.validaCaracteresIcon('caracterMayuscula')} >
                                                    </span>
                                                    <div className={this.validaCaracteresColor('caracterMayuscula')}>
                                                        <label className="label-text-modal-password">Debe contener al menos una mayúscula.</label>
                                                    </div>
                                                </div>
                                                <div className={modalValidPassBodyCam}>
                                                    <span style={{ margin: { estiloColpxCam }, width: '28px' }} className={this.validaCaracteresIcon('caracteresAlfabeticos')} >
                                                    </span>
                                                    <div className={this.validaCaracteresColor('caracteresAlfabeticos')}>
                                                        <label className="label-text-modal-password">Debe contener al menos cuatro caracteres alfabéticos.</label>
                                                    </div>
                                                </div>
                                                <div className={modalValidPassBodyCam}>
                                                    <span style={{ margin: { estiloColpxCam }, width: '8%' }} className={this.validaCaracteresIcon('caracteresNumericos')} >
                                                    </span>
                                                    <div className={this.validaCaracteresColor('caracteresNumericos')}>
                                                        <label className="label-text-modal-password">Debe contener al menos un caracter numerico.</label>
                                                    </div>
                                                </div>
                                                <div className={modalValidPassBodyCam}>
                                                    <span style={{ margin: { estiloColpxCam }, width: '8%' }} className={this.validaCaracteresIcon('caracterEspecial')} >
                                                    </span>
                                                    <div className={this.validaCaracteresColor('caracterEspecial')}>
                                                        <label className="label-text-modal-password">Debe contener al menos un caracter especial.</label>
                                                    </div>
                                                </div>
                                                <div className={modalValidPassBodyCam}>
                                                    <span style={{ margin: { estiloColpxCam } }} className={this.validaCaracteresIcon('caracterGNP')} >
                                                    </span>
                                                    <div className={this.validaCaracteresColor('caracterGNP')}>
                                                        <label className="label-text-modal-password">No debe contener la palabra GNP.</label>
                                                    </div>
                                                </div>
                                                <div className={modalValidPassBodyCam}>
                                                    <span style={{ margin: { estiloColpxCam }, width: '13%' }} className={this.validaCaracteresIcon('caracterConsecutivoIgual')} >
                                                    </span>
                                                    <div className={this.validaCaracteresColor('caracterConsecutivoIgual')}>
                                                        <label className="label-text-modal-password">No debe contener más de dos caracteres
                                                            consecutivos iguales (p.e. 222, eee).</label>
                                                    </div>
                                                </div>
                                                <div className={modalValidPassBodyCam}>
                                                    <span style={{ margin: { estiloColpxCam }, width: '13%' }} className={this.validaCaracteresIcon('caracterConsecutivo')} >
                                                    </span>
                                                    <div className={this.validaCaracteresColor('caracterConsecutivo')}>
                                                        <label className="label-text-modal-password">No debe contener más de dos caracteres
                                                            consecutivos (p.e. 123, abc).</label>
                                                    </div>
                                                </div>
                                                <div className={modalValidPassBodyCam}>
                                                    <span style={{ margin: { estiloColpxCam } }} className={this.validaCaracteresIcon('espacioEnBlanco')} >
                                                    </span>
                                                    <div className={this.validaCaracteresColor('espacioEnBlanco')}>
                                                        <label className="label-text-modal-password">No debe contener espacios en blanco.</label>
                                                    </div>
                                                </div>
                                            </div>}
                                    </div>
                                    <div className="col-md-6 col-sm-12" id="campo-password-cambiaPassword">
                                        <Field
                                            name="confpassword" label="Confirma tu nueva contraseña" component={campo} max="24"
                                            type={this.state.showConfPass ? "password" : "text"} onBlur={this.confirmPasswordCambia}
                                            error={this.state.errorRequeridoContraConfir ? campoRequ : null}
                                            props={{ param: this.state.showConfPass, fnToggle: this.toggleCambia.bind(this, "showConfPass"), clase: "confpass" }}
                                        />
                                        <button type="button" className={this.state.showConfPass ? ojito : ojitoCerrado} onClick={() => { this.viewPassConf() }}></button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6" style={{ marginTop: "40px" }}>
                                <button id="btn-continuar-cambioPass"
                                    style={{ width: '120px', height: '48px', fontSize: '16px', padding: '14px 16px', marginLeft: "27%" }}
                                    className="orange-rectangle" onClick={this.sigue}>Continuar</button>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-2'></div>
                </div>
            </div>

            <div className='modal fade' id='modal-final' tabIndex='-1' role='dialog' aria-labelledby='modal-final'
                style={{ marginLeft: '19%' }}>
                <div className='modal-dialog' role="document">
                    <div className='modal-content modal-content-final'>
                        <div className='modal-header' style={{ padding: '0px 15px' }}>
                            <span className='icon-circle-dove icono-modal-final' ></span>
                            <h4 className='modalfin-title' >
                                Cambio exitoso
                            </h4>
                        </div>
                        <div className='modal-body-final'>
                            <p>Tu contraseña fue restablecida con éxito.</p>
                            <p> </p>
                        </div>
                        <div className='modal-footer' style={{ marginTop: '-5px', padding: '0px' }}>
                            <button type='button' className='btn-orange-modal-final'
                                data-dismiss='modal' onClick={this.cierraModal}>Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
CambiarContrasena = reduxForm({ form: "datosSeguridad" })(CambiarContrasena);
export default connect(mapState, mapDispatch)(CambiarContrasena);



// WEBPACK FOOTER //
// ./src/miPerfil/cambiarContrasena.frm.js